import { pricesAtom } from "@/modules/pricing/pricingQuery.ts";
import { getBucketPrice } from "@/modules/pricing/resourcePricing.ts";
import { bucketListQuery, type BucketWithPrice } from "@/modules/storage/bucket/bucketApi.ts";
import { mergeLoadedQueries, type QMergedResult } from "@/utils/query/mergeQueries.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { mapOnValues } from "@warrenio/utils/collections/maps";
import { atom } from "jotai/vanilla";

export const bucketListQueryAtom = atomFromStandardQueryOptions(bucketListQuery);

export const bucketListQueryWithPricesAtom = atom((get): QMergedResult<Map<string, BucketWithPrice> | undefined> => {
    return mergeLoadedQueries(
        {
            buckets: get(bucketListQueryAtom),
            prices: get(pricesAtom),
        },
        ({ buckets, prices }) =>
            mapOnValues(
                buckets,
                (bucket): BucketWithPrice => ({
                    ...bucket,
                    price: getBucketPrice(prices, bucket),
                }),
            ),
    );
});
